orders-planner-dialog-tooltip-schedule(class="{show: isShow}")
  .orders-planner-dialog-tooltip-schedule.popper
    planner-tooltip-detail(tag-scope="planner_tooltip_detail")
    .popper__arrow(x-arrow)
  script(type="typescript").
    this.mixin('orders.planner.dialog.tooltip-schedule');
